import { render, staticRenderFns } from "./BasicSetting.vue?vue&type=template&id=3d23ad9a&scoped=true"
import script from "./BasicSetting.vue?vue&type=script&lang=js"
export * from "./BasicSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23ad9a",
  null
  
)

export default component.exports